
import axios from 'axios';

import { showAlert } from './alerts';



export const login = async (email, password) => {

	try {

		const result = await axios({

			method: 'POST',
			url: '/api/v1/users/login',
			data: {
				email,
				password
			}
		});

		if (result.data.status === 'success') {

			showAlert('success', 'Logged in successfully!!');

			window.setTimeout(() => {

				location.assign('/')

			}, 2500
			)
		}
	} catch (err) {

		showAlert('error', err.response.data.message);
	}
}



export const logout = async () => {

	try {

		const res = await axios({

			method: 'GET',
			url: '/api/v1/users/logout',
		});

		if (res.data.status === 'success') {

			showAlert('success', 'Logged out successfully!!');

			window.setTimeout(() => {

				location.assign('/login')

			}, 2500)
		}
	} catch (err) {

		showAlert('error', 'Error logging out.... try again!');
	}
}





export const signup = async (name, email, password, passwordConfirm) => {

	try {

		const result = await axios({

			method: 'POST',
			url: '/api/v1/users/signup',
			data: {
				name,
				email,
				password,
				passwordConfirm
			}
		});

		if (result.data.status === 'success') {

			showAlert('success', 'Sign up Successful!! <br>Please check your inbox for account customization details.');

			window.setTimeout(() => {

				location.assign('/')

			}, 5000
			)
		}
	} catch (err) {

		showAlert('error', err.response.data.message);
	}
}
